import { render } from "./Certificates.vue?vue&type=template&id=6953f0b7&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"

import "./Certificates.vue?vue&type=style&index=0&id=6953f0b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6953f0b7"]])

export default __exports__